const { setInitialised, useArrows } = window.BAO.Carousel.plugins
export class CartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
  }

  render () {
    fetch(this.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendationsCheck = html.querySelector('[data-cart-recommendations-carousel-el="slides"]')
        const recommendations = html.querySelector('cart-recommendations')
        const hasItems =
          recommendations && recommendationsCheck.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.crt-Recommendations')
            .forEach(container => {
              container.innerHTML = recommendations.innerHTML
            })
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations)
}

class CartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  setupListeners() {
    super.setupListeners()
    window.addEventListener('resize', () => this.onResize())
  }

  render() {
    if (!this.els?.slide?.exists) return
    this.carousel = this.setupCarousel()
    this.updateCarouselHeight() // Update height after initializing the carousel
  }

  onResize() {
    if (this.carousel) {
      this.carousel.update()
      this.updateCarouselHeight() // Update height on window resize
    }
  }

  setupCarousel() {
    this.carousel = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.8,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 10,
            },
          },
        },
        breakpoints: {
          '(min-width: 1301px)': {
            slides: {
              perView: 2.6,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
          hideArrows: true,
        }),
      ],
    )

    this.carousel.on('created', () => {
      this.updateCarouselHeight()
    })

    this.carousel.on('updated', () => {
      this.updateCarouselHeight()
    })

    return this.carousel
  }

  updateCarouselHeight() {
    if (window.innerWidth <= 769) {
      requestAnimationFrame(() => {
        const height = this.offsetHeight
        document.body.style.setProperty('--Carousel_Height', `${height}px`)
      })
    } else {
      document.body.style.removeProperty('--Carousel_Height')
    }
  }
}

if (!customElements.get('cart-recommendations-carousel')) {
  customElements.define(
    'cart-recommendations-carousel',
    CartRecommendationsCarousel,
  )
}
